import React, { useEffect, useState } from "react";
import $ from "jquery";
import "turn.js";
import Swipe from 'react-easy-swipe';
import {TweenMax, Power4} from 'gsap'
import {useDrag, useGesture, useWheel} from 'react-use-gesture'
import { last } from "lodash-es";

class Turn extends React.Component {
    static defaultProps = {
      style: {},
      className: "",
      options: {},
      mainScrolling: false
    };
  
    componentDidMount() {
      if (this.elMob) {
        $(this.elMob).turn(Object.assign({}, this.props.options));
        // $(this.elMob).turn("size", '100px', '100px');
      }
      document.addEventListener("keydown", this.handleKeyDown, false);
      window.addEventListener("resize", this.handleResize);
      window.addEventListener('scroll', this.scrollListener, true)

      setTimeout(()=>{
        $(this.elMob).turn("next")
        TweenMax.to(this.navArrowRef, 0.3, {
          css: {
            opacity: 1,
            ease: Power4.easeInOut,
          },
        }).delay(1.8).then(()=>{
          this.props.setShowInsrtuctionOverlay(true)
        })
      },3000)
    }
  
    componentWillUnmount() {
      if (this.elMob) {
        $(this.elMob)
          .turn("destroy")
          .remove();
      }
      document.removeEventListener("keydown", this.handleKeyDown, false);
      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener('scroll', this.scrollListener, true)
    }

    componentDidUpdate(prevProps, prevState, snapshot){
      if(this.props.showInitialPeel){
        // setTimeout(()=>{
        //   $(this.elMob).turn("peel", 'br')
        // },200)
        this.props.setShowInitialPeel(false)
      }
    }
  
    handleKeyDown = event => {
      if (event.keyCode === 37 && $(this.elMob).turn('view')[0] !== 2) {
        $(this.elMob).turn("previous");
      }
      if (event.keyCode === 39 && $(this.elMob).turn('view')[0] !== 0) {
        $(this.elMob).turn("next");
      }
    };

    scrollListener = () => {
      $(this.elMob).turn("peel", false);
    }

    handleResize = event => {
      
      console.warn('listening')
      
      if(window.innerWidth < 600){
        console.warn('small')
        $(this.elMob).turn("size", `${window.innerWidth*2}px`, `${window.innerHeight}px`);
      }else{
        $(this.elMob).turn("size", '200%', `${window.innerHeight}px`);
      }
    }
  
    render() {

      return (
        <>
          <CustomSwiperHandler 
              swipeRight={()=> {
                if(!($(this.elMob).turn('animating')) && !this.props.mainScrolling){
                  $(this.elMob).turn('view')[0] !== 2 && $(this.elMob).turn("previous")
                }
                }
              }
              swipeLeft={()=> {
                if(!($(this.elMob).turn('animating')) && !this.props.mainScrolling){
                  $(this.elMob).turn('view')[0] !== 0 && $(this.elMob).turn("next")
                }
                }
              }
              setMainScrolling = {(status) => this.setState({mainScrolling: status})}
            >
            <div style={{width:'100%', overflow:'hidden'}}>

              <div
              className={this.props.className}
              style={Object.assign({}, this.props.style)}
              ref={elMob => (this.elMob = elMob)}
              >
                {this.props.children}
              </div>
            </div>
            <div style={{opacity:0}} ref={ref=> {this.navArrowRef  = ref}}>
              <div id='next-arrow' style={{transform:"translateX(80px)"}} onClick={()=>{
                $(this.elMob).turn("next");
              }} className="swiper-button-next"></div>
                <div id='prev-arrow' style={{transform:"translateX(-80px)"}} 
                onClick={()=>{
                  $(this.elMob).turn("view")[0] !== 2 && $(this.elMob).turn("previous");
                }}
                className="swiper-button-prev" ></div>
            </div>
          </CustomSwiperHandler>
        </>
      );
    }
  }
  export default Turn

  const CustomSwiperHandler = ({swipeLeft, swipeRight, children, peel, setMainScrolling}) => {

    // useEffect(()=>{
    //   const element = document.querySelector('.swipe-section-container');
  
    //   element.addEventListener('touchstart', (e) => {
  
    //       // is not near edge of view, exit
    //       if (e.pageX > 10 && e.pageX < window.innerWidth - 10) return;
  
    //       // prevent swipe to navigate gesture
    //       e.preventDefault();
    //   });
    // }, [])


    const gesture = useDrag((e)=>{
      let { wheeling,xy:[x, y], initial:[iniX, iniY] ,memo,down, delta: [xDelta], velocity, last ,direction: [xDir, yDir], distance, cancel, swipe:[swiX,swiY],moving } = e
      let yAxis = iniY - y
      console.warn(yAxis)
      if((last && x - iniX > 100 && (yAxis <= 50 && yAxis > -50)) || (swiX>0 && swiY === 0)){
        if(!wheeling){
          swipeRight()
        }
      }
      if((last && iniX - x > 100 && (yAxis <= 50 && yAxis > -50) || (swiX<0 && swiY === 0)) ){
        if(!wheeling){
          swipeLeft()
        }
      }
      console.warn(e)
    },{
      swipeVelocity:0.2,
      rubberband:true,
      lockDirection: true
    })

    return(
      <div 
      className="swipe-section-container"
      {...gesture()}
          >
        {children}
      </div>
    )
  }